<template>
  <div id="api" :key="new Date().getTime()">
    <iframe
      class="apiframe"
      frameborder="0"
      style="width: 100%; height: 100%"
      :src="url"
    ></iframe>
  </div>
</template>

<script>
import { getCookie } from '../common/utils';
export default {
  data() {
    return {
      url: "/API/api.html"
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.$nextTick(() => {
        if(!getCookie('nowurl')){
          document.cookie = "nowurl=./json/swagger_3151.json; path=/API";
        }
        if(!getCookie('nowHostUrl')){
            document.cookie = "nowHostUrl=PRD; path=/API";
        }
      })
      let nowhref = window.location.href;
      let site = nowhref.indexOf("#");
      if (site > 0) {
        nowhref = nowhref.slice(site);
        this.url = this.url + nowhref;
      }
    },
  },
};
</script>

<style lang="less">
#network {
  width: 100%;
  height: calc(100vh - 60px);
}
.app {
  height: 100%;
  #content {
    height: calc(100% - 65px);
    #api {
      height: calc(100%);
      overflow: hidden;
    }
  }
}
</style>
